class CloudStrike {

    constructor() {
        this.jupiterapi = 'https://jupiterapi.colorspace.cloud';
        this.useAuth = false;
    }

    static LINK_TYPE = {
        'curveLink': 'CRVDL',
        'swapLink': 'SWPDL',
        'spyLink': 'SPYDL'
    };

    isoTime() {
        return new Date().toISOString().replace(/[:.]/g, '-');
    }

    generateDownloadLink(blob, fileName) {
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
    }
    
    base64ToBlob(base64String) {
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/octet-stream' });
        return blob;
    }

    async sendRequest(endpoint, requestOptions) {

        if (this.useAuth === true) {
            const token = sessionStorage.getItem('jptr-token');
            if (token == null) {
                //logout();
                return;
            }
            requestOptions.headers.Authorization = `Bearer ${token}`;
        }

        return fetch(`${this.jupiterapi}${endpoint}`, requestOptions)
        .then((response) => response.json())
        .then((data) => { return data; })
        .catch((error) => { throw error; });
    }

    /**
     * Downlaod a link.
     * @param {*} fileID FileID
     * @param {*} typeID TypeID - CRVDL, SWPDL, SPYDL
     * @returns 
     */
    async downloadLink(fileID, typeID) {

        const requestOptions = {
            method: "GET",
            headers: {},
            redirect: "follow"
        };

        return this.sendRequest(
            `/file/download/link?fileID=${fileID}&type=${typeID}`,
            requestOptions
        )
        .then(result => {
            const blob = this.base64ToBlob(result.body);
            this.generateDownloadLink(blob, `${fileID}.icc`);
        })
        .catch(error => { throw error; });
    }

    async downloadFile(fileID, extension, typeID="") {

        const requestOptions = {
            method: "GET",
            headers: {},
            redirect: "follow"
        };

        if (typeID) {
            typeID = `&type=${typeID}`;
        }

        return this.sendRequest(
            `/file/download/file?fileID=${fileID}${typeID}&extension=${extension}`, 
            requestOptions
        )
        .then(result => {
            const blob = this.base64ToBlob(result.body);
            this.generateDownloadLink(blob, `${fileID}.${extension}`);
        })
        .catch(error => { throw error; });
    }

    async downloadPreview(fileID) {

        const requestOptions = {
            method: "GET",
            headers: {},
            redirect: "follow"
        };

        this.useAuth = false;

        return this.sendRequest(
            `/file/download/file?fileID=${fileID}&type=PRV&extension=png`,
            requestOptions
        )
        .then(data => { return `data:image/png;base64,${data.body}`; })
        .catch(error => { throw error; });
    }

    async downloadPage(fileID) {
    
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "fileID": fileID
            }),
            redirect: "follow"
        };

        return this.sendRequest(
            `/file/download/statics`,
            requestOptions
        )
        .then(result => {
            const presigned = JSON.parse(result.body);
            return fetch(presigned.url);
        })
        .then(async fileResponse => {
            const blob = await fileResponse.blob();
            this.generateDownloadLink(blob, `${fileID}-${this.isoTime()}.tif`);
        })
        .catch(error => { throw error; })
    }


    async createSeparation(fileID, previewSize) {

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "fileID": fileID,
                "previewSize": previewSize
            }),
            redirect: "follow"
        };

        return this.sendRequest(
            `/trafo/separation`,
            requestOptions
        )
        .then(data => { return data.body; })
        .catch(error => { throw error; });
    }


    /**
     * 
     * @param {*} fileID 
     * @param {*} previewSize Maximum size of the preview image in pixels.
     * @param {*} special_ink_type flood, fill, pixel, ...
     * @returns 
     */
    async createSpecialInkSeparation(fileID, previewSize, special_ink_type, special_ink_settings = {}) {

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "fileID": fileID,
                "preview_size": previewSize,
                "special_ink_type": special_ink_type,
                /* "expansion": 0, */
                ...special_ink_settings
            }),
            redirect: "follow"
        };

        return this.sendRequest(
            `/trafo/specialink`,
            requestOptions
        )
        .then(data => { return data.body; })
        .catch(error => { throw error; });
    }



    /**
     * Upload a (TIF) file less than 10MB..
     *
     * @param {File} fileObject - Das Dateiobjekt, das hochgeladen werden soll.
     * @returns {Promise<void>} - Ein Promise, das aufgelöst wird, wenn der Upload abgeschlossen ist.
     */
    async uploadFile(fileObject) {
        
        const maxSize = 10 * 1024 * 1024;

        if (!fileObject) {
            alert("Bitte wählen Sie eine Datei aus.");
            return;
        }
        if (fileObject.size > maxSize) {
            alert("Die Datei ist zu groß. Bitte wählen Sie eine Datei, die kleiner als 10 MB ist.");
            return;
        }
            
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "image/tiff"
            },
            body: fileObject,
            redirect: "follow"
        };

        return this.sendRequest(
            '/file/upload/image', 
            requestOptions
        )
        .catch(error => { throw error; });
    }

    async statusFile(fileID) {

        const requestOptions = {
            method: "GET",
            headers: {},
            redirect: "follow"
        };

        return this.sendRequest(
            `/file/status?filename=${fileID}`,
            requestOptions
        )
        .catch(error => { throw error; });
    }
}

class Pulse {

    constructor(element) {
        this.element = element;
        this.isPulsing = false;
    }

    start() {
        if (this.isPulsing) {
            return;
        }

        this.element.style.display = 'block';
        this.element.classList.add('pulsing');
        this.isPulsing = true;
    }

    stop() {
        if (!this.isPulsing) {
            return;
        }

        this.element.classList.remove('pulsing');
        this.element.style.display = 'none';
        this.isPulsing = false;
    }

    info(text) {
        this.element.textContent = text;
    }
}

export { 
    CloudStrike, 
    Pulse 
};
